import { render, staticRenderFns } from "./ChannelAdd.vue?vue&type=template&id=5dff98ff&scoped=true"
import script from "./ChannelAdd.vue?vue&type=script&lang=js"
export * from "./ChannelAdd.vue?vue&type=script&lang=js"
import style0 from "./ChannelAdd.vue?vue&type=style&index=0&id=5dff98ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff98ff",
  null
  
)

export default component.exports